import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { HeaderService } from '../header-information/header-information.service';
import { RouterStackService, ModalDialogNotificationService } from '@se/se.ui.html5';
import { CanPageDeactiveDialogService } from '../services/canpagedeactivedialog.service';
import { EstensaNotificationService } from '../services/angularjs/estensa-notification.service';

@Injectable({ providedIn: 'root' })
export class PageService {

    // data members

    private _translateService: TranslateService;
    get translateService() {
        return this._translateService;
    }

    private _headerService: HeaderService;
    get headerService() {
        return this._headerService;
    }

    private _routerStackService: RouterStackService;
    get routerStackService() {
        return this._routerStackService;
    }

    private _notificationService: EstensaNotificationService;
    get notificationService() {
        return this._notificationService;
    }

    private _modalDialogNotificationService: ModalDialogNotificationService;
    get modalDialogNotificationService() {
        return this._modalDialogNotificationService;
    }

    private _canPageDeactiveDialogService: CanPageDeactiveDialogService;
    get canPageDeactiveDialogService() {
        return this._canPageDeactiveDialogService;
    }

    // constructor

    constructor(
        translateService: TranslateService,
        headerService: HeaderService,
        routerStackService: RouterStackService,
        notificationService: EstensaNotificationService,
        modalDialogNotificationService: ModalDialogNotificationService,
        canPageDeactiveDialogService: CanPageDeactiveDialogService) {

            this._translateService = translateService;
            this._headerService = headerService;
            this._routerStackService = routerStackService;
            this._notificationService = notificationService;
            this._modalDialogNotificationService = modalDialogNotificationService;
            this._canPageDeactiveDialogService = canPageDeactiveDialogService;
    }
}
